import { takeLatest } from 'redux-saga/effects';
import {
	getDocumentListSuccess, getDocumentListFail,
	getDocumentDetailsSuccess, getDocumentDetailsFail,

	getEmployeeDocumentListSuccess, getEmployeeDocumentListFail,
	getEmployeeDocumentDetailsSuccess, getEmployeeDocumentDetailsFail,
} from './documentState';

import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/workforce/documents');
const redirectData = { route: '/console/documents', mode: 'list', recordId: 0 };
const modelName = 'Document';
const modelId = 'doc_id';
const employeeCrudService = createCrudService('api/v1/workforce/employees');

function* getDocumentList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getDocumentListSuccess,
		getDocumentListFail, 
		null, null, LOADING_MSG
	);
}

function* getDocumentDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getDocumentDetailsSuccess, 
		getDocumentDetailsFail, 
		null, null, LOADING_MSG
	);		
}

function* doDocumentCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getDocumentDetailsSuccess, 
		getDocumentDetailsFail, 
		createRecordSuccess(modelName),
		{ ...redirectData, mode: 'reload' },
		SAVING_MSG
	);
}

function* doDocumentUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getDocumentDetailsSuccess, 
		getDocumentDetailsFail, 
		updateRecordSuccess(modelName),
		{ ...redirectData, mode: 'reload' },
		UPDATING_MSG
	);	
}

function* doDocumentDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getDocumentDetailsSuccess, 
		getDocumentDetailsFail, 
		deleteRecordSuccess(modelName),
		{ ...redirectData, mode: data.payload.mode },
		DELETING_MSG
	);	
}

function* getEmployeeDocumentList(data) {
	const { recordId, ...params } = data.payload;
	console.log('getEmployeeDocumentList saga called with:', {
        recordId,
        params,
        childEndpoint: `${recordId}/documents`
    });
	const childEndpoint = `${recordId}/documents`;
	console.log('Full API URL:', `api/v1/workforce/employees/${childEndpoint}`);
	yield doCrudCall(
		() => employeeCrudService.getList(params, childEndpoint ), 
		getEmployeeDocumentListSuccess, 
		getEmployeeDocumentListFail,
		null, null, LOADING_MSG);
}

function* getEmployeeDocumentDetails(data) {
	const { docId, recordId } = data.payload;
	const childEndpoint = `${docId}/documents`;
	yield doCrudCall(
		() => employeeCrudService.getDetails(recordId, childEndpoint), 
		getEmployeeDocumentDetailsSuccess, 
		getEmployeeDocumentDetailsFail, 
		null, null, LOADING_MSG);		
}

function* doEmployeeDocumentCreate(data){
	const doc_employee_id = data.payload.doc_employee_id;
	const childEndpoint = `${doc_employee_id}/documents`;
	yield doCrudCall(
		() => employeeCrudService.doCreate(data.payload, childEndpoint), 
		getEmployeeDocumentDetailsSuccess, 
		getEmployeeDocumentDetailsFail, 
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doEmployeeDocumentUpdate(data){
	const { employeeId, doc_id} = data.payload;
	const childEndpoint = `${employeeId}/documents`;
	yield doCrudCall(
		() => employeeCrudService.doUpdate(doc_id, data.payload, childEndpoint), 
		getEmployeeDocumentDetailsSuccess, 
		getEmployeeDocumentDetailsFail, 
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);		
}

function* doEmployeeDocumentDelete(data){
	const { employeeId, recordId} = data.payload;
	const childEndpoint = `${employeeId}/documents`;
	yield doCrudCall(
		() => employeeCrudService.doDelete(recordId, childEndpoint), 
		getEmployeeDocumentDetailsSuccess, 
		getEmployeeDocumentDetailsFail, 
		deleteRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		DELETING_MSG);		
}

function* documentSaga() {
	yield takeLatest('document/getDocumentList', getDocumentList);
	yield takeLatest('document/getDocumentDetails', getDocumentDetails);
	yield takeLatest('document/doDocumentCreate', doDocumentCreate);
	yield takeLatest('document/doDocumentUpdate', doDocumentUpdate);
	yield takeLatest('document/doDocumentDelete', doDocumentDelete);
	yield takeLatest('document/getEmployeeDocumentList', getEmployeeDocumentList);
	yield takeLatest('document/getEmployeeDocumentDetails', getEmployeeDocumentDetails);
	yield takeLatest('document/doEmployeeDocumentCreate', doEmployeeDocumentCreate);
	yield takeLatest('document/doEmployeeDocumentUpdate', doEmployeeDocumentUpdate);
	yield takeLatest('document/doEmployeeDocumentDelete', doEmployeeDocumentDelete);

}

export default documentSaga;
